import type { MouseEvent, KeyboardEvent } from 'react';
import utils from '../../../utils';
import Icon, { IconClassName } from '../../generic/Icon';
import Flex from '../../generic/Flex';

type ProjectSummaryActionButtonProps = {
  text: string;
  icon: IconClassName;
  iconHasSpin?: boolean;
  onAction: (event: MouseEvent | KeyboardEvent) => void;
};

const ProjectSummaryActionButton = ({ text, icon, iconHasSpin = false, onAction }: ProjectSummaryActionButtonProps) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a
    onKeyPress={utils.onEnter(onAction)}
    onClick={onAction}
    role="button"
    tabIndex={0}
  >
    <Flex justify="flex-start">
      <Icon icon={icon} hasSpin={iconHasSpin} />
      <div className="margin-left-md">{text}</div>
    </Flex>
  </a>
);

export default ProjectSummaryActionButton;
